export const properties = [
  {
    "wdtId": "444",
    "id": "250.227.045",
    "title": "Human Bean - Marianna, Florida",
    "price": "$ 1,200,000",
    "capRate": "6.00%",
    "netRent": "$ 6,000/mo",
    "priceValue": 1200000,
    "capRateValue": 6,
    "tenant": "Human Bean",
    "leaseTerm": "in 15 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Florida",
    "location": "Marianna, Florida",
    "yearBuilt": 2024,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Human Bean listing in Marianna, Florida.",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Human Bean in Marianna, Florida. Human Bean listing in Marianna, Florida.",
    "status": "Active",
    "streetAddress": "4380 Lafayette St",
    "city": "Marianna",
    "zipCode": "32.446",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.220.240",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5112767/summary",
    "notes": "Human Bean listing in Marianna, Florida.",
    "selectPropertyState": "FLORIDA PROPERTIES",
    "askingPrice": "$ 1,200,000",
    "expires": "in 15 years",
    "built": 2024
  },
  {
    "wdtId": "445",
    "id": "250.225.012",
    "title": "Dollar Tree - Akron, Ohio",
    "price": "$ 1,222,000",
    "capRate": "8.00%",
    "netRent": "$ 8,146/mo",
    "priceValue": 1222000,
    "capRateValue": 8,
    "tenant": "Dollar Tree",
    "leaseTerm": "in 6 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Ohio",
    "location": "Akron, Ohio",
    "yearBuilt": 2015,
    "assetType": "Essential Retail",
    "corporateCredit": "(3) 5-year renewal options",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Dollar Tree in Akron, Ohio. (3) 5-year renewal options",
    "status": "Active",
    "streetAddress": "2188 E Market St",
    "city": "Akron",
    "zipCode": "44.312",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "9.929.475",
    "linkToProperty": "For Sale | 2188 E Market St - Dollar Tree",
    "notes": "(3) 5-year renewal options",
    "selectPropertyState": "OHIO PROPERTIES",
    "askingPrice": "$ 1,222,000",
    "expires": "in 6 years",
    "built": 2015
  },
  {
    "wdtId": "446",
    "id": "250.225.006",
    "title": "Popeyes - Monroe, Louisiana",
    "price": "$ 1,240,000",
    "capRate": "6.25%",
    "netRent": "$ 6,458/mo",
    "priceValue": 1240000,
    "capRateValue": 6.25,
    "tenant": "Popeyes",
    "leaseTerm": "in 10 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Louisiana",
    "location": "Monroe, Louisiana",
    "yearBuilt": 2024,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Three (3) extension periods of five (5) years each, providing a strong long-term",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Popeyes in Monroe, Louisiana. Three (3) extension periods of five (5) years each, providing a strong long-term",
    "status": "Active",
    "streetAddress": "1950 Louisville Ave",
    "city": "Monroe",
    "zipCode": "71.201",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "7.399.250",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5176616/property",
    "notes": "Three (3) extension periods of five (5) years each, providing a strong long-term",
    "selectPropertyState": "LOUISIANA PROPERTIES",
    "askingPrice": "$ 1,240,000",
    "expires": "in 10 years",
    "built": 2024
  },
  {
    "wdtId": "447",
    "id": "250.227.025",
    "title": "Dollar General - Brasil, Indiana",
    "price": "$ 1,295,291",
    "capRate": "7.25%",
    "netRent": "$ 7,825/mo",
    "priceValue": 1295291,
    "capRateValue": 7.25,
    "tenant": "Dollar General",
    "leaseTerm": "in 12 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Indiana",
    "location": "Brasil, Indiana",
    "yearBuilt": 2021,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Brasil, Indiana.",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Brasil, Indiana. Dollar General listing in Brasil, Indiana.",
    "status": "Active",
    "streetAddress": "3828 India 59",
    "city": "Brasil",
    "zipCode": "47.834",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "13.480.599",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5287507/property/",
    "notes": "Dollar General listing in Brasil, Indiana.",
    "selectPropertyState": "INDIANA PROPERTIES",
    "askingPrice": "$ 1,295,291",
    "expires": "in 12 years",
    "built": 2021
  },
  {
    "wdtId": "448",
    "id": "250.227.047",
    "title": "Checkers - Tallahassee, Florida",
    "price": "$ 1,340,000",
    "capRate": "6.16%",
    "netRent": "$ 6,878/mo",
    "priceValue": 1340000,
    "capRateValue": 6.16,
    "tenant": "Checkers",
    "leaseTerm": "in 10 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Florida",
    "location": "Tallahassee, Florida",
    "yearBuilt": 2017,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Checkers listing in Tallahassee, Florida.",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Checkers in Tallahassee, Florida. Checkers listing in Tallahassee, Florida.",
    "status": "Active",
    "streetAddress": "3117 Mahan Dr",
    "city": "Tallahassee",
    "zipCode": "32.308",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "10.073.076",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5270637/summary",
    "notes": "Checkers listing in Tallahassee, Florida.",
    "selectPropertyState": "FLORIDA PROPERTIES",
    "askingPrice": "$ 1,340,000",
    "expires": "in 10 years",
    "built": 2017
  },
  {
    "wdtId": "449",
    "id": "250.227.017",
    "title": "MEDICAL - Soddy Daisy, Tennessee",
    "price": "$ 1,435,406",
    "capRate": "7.25%",
    "netRent": "$ 8,672/mo",
    "priceValue": 1435406,
    "capRateValue": 7.25,
    "tenant": "MEDICAL",
    "leaseTerm": "in 4 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Tennessee",
    "location": "Soddy Daisy, Tennessee",
    "yearBuilt": 2017,
    "assetType": "Medical / Specialty",
    "corporateCredit": "Fast Pace Health",
    "image": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for MEDICAL in Soddy Daisy, Tennessee. Fast Pace Health",
    "status": "Active",
    "streetAddress": "9325 Dayton Pike",
    "city": "Soddy Daisy",
    "zipCode": "37.379",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "11.360.955",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5142936/property",
    "notes": "Fast Pace Health",
    "selectPropertyState": "TENNESSEE PROPERTIES",
    "askingPrice": "$ 1,435,406",
    "expires": "in 4 years",
    "built": 2017
  },
  {
    "wdtId": "450",
    "id": "250.227.014",
    "title": "Dollar General - Kingman, Arizona",
    "price": "$ 1,470,124",
    "capRate": "7.25%",
    "netRent": "$ 8,881/mo",
    "priceValue": 1470124,
    "capRateValue": 7.25,
    "tenant": "Dollar General",
    "leaseTerm": "in 7 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Arizona",
    "location": "Kingman, Arizona",
    "yearBuilt": 2017,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Kingman, Arizona.",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Kingman, Arizona. Dollar General listing in Kingman, Arizona.",
    "status": "Active",
    "streetAddress": "525 W Beale St",
    "city": "Kingman",
    "zipCode": "86.401",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "10.340.625",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5240777/property",
    "notes": "Dollar General listing in Kingman, Arizona.",
    "selectPropertyState": "ARIZONA PROPERTIES",
    "askingPrice": "$ 1,470,124",
    "expires": "in 7 years",
    "built": 2017
  },
  {
    "wdtId": "451",
    "id": "250.225.005",
    "title": "Popeyes - Vienna, West Virginia",
    "price": "$ 1,520,000",
    "capRate": "6.25%",
    "netRent": "$ 7,916/mo",
    "priceValue": 1520000,
    "capRateValue": 6.25,
    "tenant": "Popeyes",
    "leaseTerm": "in 6 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "West Virginia",
    "location": "Vienna, West Virginia",
    "yearBuilt": 2016,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Popeyes listing in Vienna, West Virginia.",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Popeyes in Vienna, West Virginia. Popeyes listing in Vienna, West Virginia.",
    "status": "Active",
    "streetAddress": "311 Grand Central Ave",
    "city": "Vienna",
    "zipCode": "26.105",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "11.099.140",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5260338/summary",
    "notes": "Popeyes listing in Vienna, West Virginia.",
    "selectPropertyState": "WEST VIRGINIA PROPERTIES",
    "askingPrice": "$ 1,520,000",
    "expires": "in 6 years",
    "built": 2016
  },
  {
    "wdtId": "452",
    "id": "250.227.032",
    "title": "Dollar General - West Columbia, South Carolina",
    "price": "$ 1,575,000",
    "capRate": "6.75%",
    "netRent": "$ 8,859/mo",
    "priceValue": 1575000,
    "capRateValue": 6.75,
    "tenant": "Dollar General",
    "leaseTerm": "in 10 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "South Carolina",
    "location": "West Columbia, South Carolina",
    "yearBuilt": 2020,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in West Columbia, South Carolina.",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in West Columbia, South Carolina. Dollar General listing in West Columbia, South Carolina.",
    "status": "Active",
    "streetAddress": "624 Pine Ridge dr",
    "city": "West Columbia",
    "zipCode": "29.073",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "11.287.253",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5130676/summary",
    "notes": "Dollar General listing in West Columbia, South Carolina.",
    "selectPropertyState": "SOUTH CAROLINA PROPERTIES",
    "askingPrice": "$ 1,575,000",
    "expires": "in 10 years",
    "built": 2020
  },
  {
    "wdtId": "453",
    "id": "250.225.002",
    "title": "T-MOBILE - Williston, Florida",
    "price": "$ 1,638,000",
    "capRate": "6.50%",
    "netRent": "$ 8,872/mo",
    "priceValue": 1638000,
    "capRateValue": 6.5,
    "tenant": "T-MOBILE",
    "leaseTerm": "in 15 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Florida",
    "location": "Williston, Florida",
    "yearBuilt": 2024,
    "assetType": "Service Retail",
    "corporateCredit": "10-year net lease with 10% rental increases in initial term and option periods",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for T-MOBILE in Williston, Florida. 10-year net lease with 10% rental increases in initial term and option periods",
    "status": "Active",
    "streetAddress": "242 W Noble Ave",
    "city": "Williston",
    "zipCode": "32.696",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.871.625",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5150134/property",
    "notes": "10-year net lease with 10% rental increases in initial term and option periods",
    "selectPropertyState": "FLORIDA PROPERTIES",
    "askingPrice": "$ 1,638,000",
    "expires": "in 15 years",
    "built": 2024
  },
  {
    "wdtId": "454",
    "id": "250.227.026",
    "title": "Dollar General - Sweetwater, Tennessee",
    "price": "$ 1,655,523",
    "capRate": "6.50%",
    "netRent": "$ 8,967/mo",
    "priceValue": 1655523,
    "capRateValue": 6.5,
    "tenant": "Dollar General",
    "leaseTerm": "in 20 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Tennessee",
    "location": "Sweetwater, Tennessee",
    "yearBuilt": 2023,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Sweetwater, Tennessee.",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Dollar General in Sweetwater, Tennessee. Dollar General listing in Sweetwater, Tennessee.",
    "status": "Active",
    "streetAddress": "844 Main St",
    "city": "Sweetwater",
    "zipCode": "37.874",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.482.814",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5204016/property/",
    "notes": "Dollar General listing in Sweetwater, Tennessee.",
    "selectPropertyState": "TENNESSEE PROPERTIES",
    "askingPrice": "$ 1,655,523",
    "expires": "in 20 years",
    "built": 2023
  },
  {
    "wdtId": "455",
    "id": "250.227.013",
    "title": "Family Dollar - Corpus Christi, Texas",
    "price": "$ 1,658,447",
    "capRate": "7.15%",
    "netRent": "$ 9,881/mo",
    "priceValue": 1658447,
    "capRateValue": 7.15,
    "tenant": "Family Dollar",
    "leaseTerm": "in 10 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Texas",
    "location": "Corpus Christi, Texas",
    "yearBuilt": 2018,
    "assetType": "Essential Retail",
    "corporateCredit": "Family Dollar listing in Corpus Christi, Texas.",
    "image": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Family Dollar in Corpus Christi, Texas. Family Dollar listing in Corpus Christi, Texas.",
    "status": "Active",
    "streetAddress": "3401 Ayers St",
    "city": "Corpus Christi",
    "zipCode": "78.415",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "10.782.795",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5292876/property",
    "notes": "Family Dollar listing in Corpus Christi, Texas.",
    "selectPropertyState": "TEXAS PROPERTIES",
    "askingPrice": "$ 1,658,447",
    "expires": "in 10 years",
    "built": 2018
  },
  {
    "wdtId": "456",
    "id": "250.227.031",
    "title": "Family Dollar - Norwich, Connecticut",
    "price": "$ 1,697,466",
    "capRate": "7.75%",
    "netRent": "$ 10,962/mo",
    "priceValue": 1697466,
    "capRateValue": 7.75,
    "tenant": "Family Dollar",
    "leaseTerm": "in 6 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Connecticut",
    "location": "Norwich, Connecticut",
    "yearBuilt": 2017,
    "assetType": "Essential Retail",
    "corporateCredit": "Family Dollar listing in Norwich, Connecticut.",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Family Dollar in Norwich, Connecticut. Family Dollar listing in Norwich, Connecticut.",
    "status": "Active",
    "streetAddress": "59 Norwich Ave",
    "city": "Norwich",
    "zipCode": "6.360",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "10.165.479",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5217837/summary",
    "notes": "Family Dollar listing in Norwich, Connecticut.",
    "selectPropertyState": "CONNECTICUT PROPERTIES",
    "askingPrice": "$ 1,697,466",
    "expires": "in 6 years",
    "built": 2017
  },
  {
    "wdtId": "457",
    "id": "250.225.016",
    "title": "Dollar General - Mocksville, North Carolina",
    "price": "$ 1,791,000",
    "capRate": "6.75%",
    "netRent": "$ 10,074/mo",
    "priceValue": 1791000,
    "capRateValue": 6.75,
    "tenant": "Dollar General",
    "leaseTerm": "in 14 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "North Carolina",
    "location": "Mocksville, North Carolina",
    "yearBuilt": 2023,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Mocksville, North Carolina.",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Dollar General in Mocksville, North Carolina. Dollar General listing in Mocksville, North Carolina.",
    "status": "Active",
    "streetAddress": "1660 US-64",
    "city": "Mocksville",
    "zipCode": "27.028",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "18.890.818",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5228734/property",
    "notes": "Dollar General listing in Mocksville, North Carolina.",
    "selectPropertyState": "NORTH CAROLINA PROPERTIES",
    "askingPrice": "$ 1,791,000",
    "expires": "in 14 years",
    "built": 2023
  },
  {
    "wdtId": "458",
    "id": "250.227.003",
    "title": "Family Dollar - Houston, Texas",
    "price": "$ 1,850,000",
    "capRate": "7.31%",
    "netRent": "$ 11,269/mo",
    "priceValue": 1850000,
    "capRateValue": 7.31,
    "tenant": "Family Dollar",
    "leaseTerm": "in 15 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Texas",
    "location": "Houston, Texas",
    "yearBuilt": 2016,
    "assetType": "Essential Retail",
    "corporateCredit": "Family Dollar listing in Houston, Texas.",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Family Dollar in Houston, Texas. Family Dollar listing in Houston, Texas.",
    "status": "Active",
    "streetAddress": "2913 W Orem Dr",
    "city": "Houston",
    "zipCode": "77.045",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "10.312.297",
    "linkToProperty": "For Sale | 2913 W Orem Dr - Family Dollar Store",
    "notes": "Family Dollar listing in Houston, Texas.",
    "selectPropertyState": "TEXAS PROPERTIES",
    "askingPrice": "$ 1,850,000",
    "expires": "in 15 years",
    "built": 2016
  },
  {
    "wdtId": "459",
    "id": "250.225.015",
    "title": "Dollar General - Lake Park, Georgia",
    "price": "$ 1,855,000",
    "capRate": "6.75%",
    "netRent": "$ 10,434/mo",
    "priceValue": 1855000,
    "capRateValue": 6.75,
    "tenant": "Dollar General",
    "leaseTerm": "in 14 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Georgia",
    "location": "Lake Park, Georgia",
    "yearBuilt": 2023,
    "assetType": "Essential Retail",
    "corporateCredit": "There are 10% rent increases in each of the Five, 5-year option periods.",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Dollar General in Lake Park, Georgia. There are 10% rent increases in each of the Five, 5-year option periods.",
    "status": "Active",
    "streetAddress": "7095 Lakes Blvd",
    "city": "Lake Park",
    "zipCode": "31.636",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.307.950",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5165991/property",
    "notes": "There are 10% rent increases in each of the Five, 5-year option periods.",
    "selectPropertyState": "GEORGIA PROPERTIES",
    "askingPrice": "$ 1,855,000",
    "expires": "in 14 years",
    "built": 2023
  },
  {
    "wdtId": "460",
    "id": "250.227.043",
    "title": "Dollar General - Guernsey, Wyoming",
    "price": "$ 1,873,000",
    "capRate": "6.35%",
    "netRent": "$ 9,911/mo",
    "priceValue": 1873000,
    "capRateValue": 6.35,
    "tenant": "Dollar General",
    "leaseTerm": "in 13 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Wyoming",
    "location": "Guernsey, Wyoming",
    "yearBuilt": 2023,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Guernsey, Wyoming.",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Guernsey, Wyoming. Dollar General listing in Guernsey, Wyoming.",
    "status": "Active",
    "streetAddress": "600 W Whalen",
    "city": "Guernsey",
    "zipCode": "82.214",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.714.812",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5036882/summary/",
    "notes": "Dollar General listing in Guernsey, Wyoming.",
    "selectPropertyState": "WYOMING PROPERTIES",
    "askingPrice": "$ 1,873,000",
    "expires": "in 13 years",
    "built": 2023
  },
  {
    "wdtId": "461",
    "id": "250.225.011",
    "title": "Freddy’s - Durant, Oklahoma",
    "price": "$ 1,926,000",
    "capRate": "6.75%",
    "netRent": "$ 10,833/mo",
    "priceValue": 1926000,
    "capRateValue": 6.75,
    "tenant": "Freddy’s",
    "leaseTerm": "in 19 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Oklahoma",
    "location": "Durant, Oklahoma",
    "yearBuilt": 2018,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "7.00% Rental Escalations Every 5 Years!",
    "image": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Freddy’s in Durant, Oklahoma. 7.00% Rental Escalations Every 5 Years!",
    "status": "Active",
    "streetAddress": "1051 Westside Dr",
    "city": "Durant",
    "zipCode": "74.701",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "11.246.910",
    "linkToProperty": "For Sale | 1051 Westside Dr - Freddy's Frozen Custard & Steakburgers",
    "notes": "7.00% Rental Escalations Every 5 Years!",
    "selectPropertyState": "OKLAHOMA PROPERTIES",
    "askingPrice": "$ 1,926,000",
    "expires": "in 19 years",
    "built": 2018
  },
  {
    "wdtId": "462",
    "id": "250.225.014",
    "title": "Dollar General - Mammoth Spring, Arkansas",
    "price": "$ 1,941,000",
    "capRate": "6.75%",
    "netRent": "$ 10,918/mo",
    "priceValue": 1941000,
    "capRateValue": 6.75,
    "tenant": "Dollar General",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Arkansas",
    "location": "Mammoth Spring, Arkansas",
    "yearBuilt": 2024,
    "assetType": "Essential Retail",
    "corporateCredit": "five (5) year renewal options with 5%",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Mammoth Spring, Arkansas. five (5) year renewal options with 5%",
    "status": "Active",
    "streetAddress": "1026 US-63",
    "city": "Mammoth Spring",
    "zipCode": "72.554",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.230.139",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5118284/property",
    "notes": "five (5) year renewal options with 5%",
    "selectPropertyState": "ARKANSAS PROPERTIES",
    "askingPrice": "$ 1,941,000",
    "expires": "in 14 years",
    "built": 2024
  },
  {
    "wdtId": "463",
    "id": "250.225.003",
    "title": "T-Mobile - Wagoner, Oklahoma",
    "price": "$ 2,050,000",
    "capRate": "6.10%",
    "netRent": "$ 10,420/mo",
    "priceValue": 2050000,
    "capRateValue": 6.1,
    "tenant": "T-Mobile",
    "leaseTerm": "in 10 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Oklahoma",
    "location": "Wagoner, Oklahoma",
    "yearBuilt": 2024,
    "assetType": "Service Retail",
    "corporateCredit": "T-Mobile listing in Wagoner, Oklahoma.",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for T-Mobile in Wagoner, Oklahoma. T-Mobile listing in Wagoner, Oklahoma.",
    "status": "Active",
    "streetAddress": "208 Blake Dr",
    "city": "Wagoner",
    "zipCode": "74.467",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.852.077",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5097478/summary",
    "notes": "T-Mobile listing in Wagoner, Oklahoma.",
    "selectPropertyState": "OKLAHOMA PROPERTIES",
    "askingPrice": "$ 2,050,000",
    "expires": "in 10 years",
    "built": 2024
  },
  {
    "wdtId": "464",
    "id": "250.227.036",
    "title": "Dollar Tree - Oscoda, Michigan",
    "price": "$ 2,050,000",
    "capRate": "6.75%",
    "netRent": "$ 11,531/mo",
    "priceValue": 2050000,
    "capRateValue": 6.75,
    "tenant": "Dollar Tree",
    "leaseTerm": "in 14 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Michigan",
    "location": "Oscoda, Michigan",
    "yearBuilt": 2024,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar Tree listing in Oscoda, Michigan.",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Dollar Tree in Oscoda, Michigan. Dollar Tree listing in Oscoda, Michigan.",
    "status": "Active",
    "streetAddress": "5018 N US Highway 23",
    "city": "Oscoda",
    "zipCode": "48.750",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.798.163",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5073938/summary",
    "notes": "Dollar Tree listing in Oscoda, Michigan.",
    "selectPropertyState": "MICHIGAN PROPERTIES",
    "askingPrice": "$ 2,050,000",
    "expires": "in 14 years",
    "built": 2024
  },
  {
    "wdtId": "465",
    "id": "250.227.015",
    "title": "Popeyes - Greenwood, South Carolina",
    "price": "$ 2,052,592",
    "capRate": "6.25%",
    "netRent": "$ 10,690/mo",
    "priceValue": 2052592,
    "capRateValue": 6.25,
    "tenant": "Popeyes",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "South Carolina",
    "location": "Greenwood, South Carolina",
    "yearBuilt": 2019,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Popeyes listing in Greenwood, South Carolina.",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Popeyes in Greenwood, South Carolina. Popeyes listing in Greenwood, South Carolina.",
    "status": "Active",
    "streetAddress": "1211 NE Bypass 72",
    "city": "Greenwood",
    "zipCode": "29.649",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "11.255.063",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5224525/property",
    "notes": "Popeyes listing in Greenwood, South Carolina.",
    "selectPropertyState": "SOUTH CAROLINA PROPERTIES",
    "askingPrice": "$ 2,052,592",
    "expires": "in 14 years",
    "built": 2019
  },
  {
    "wdtId": "466",
    "id": "250.227.042",
    "title": "Dollar General - Hartfort, Connecticut",
    "price": "$ 2,053,000",
    "capRate": "6.25%",
    "netRent": "$ 10,692/mo",
    "priceValue": 2053000,
    "capRateValue": 6.25,
    "tenant": "Dollar General",
    "leaseTerm": "in 7 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Connecticut",
    "location": "Hartfort, Connecticut",
    "yearBuilt": 2016,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Hartfort, Connecticut.",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Hartfort, Connecticut. Dollar General listing in Hartfort, Connecticut.",
    "status": "Active",
    "streetAddress": "649 Wethersfield Ave",
    "city": "Hartfort",
    "zipCode": "6.114",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.220.034",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5112631/summary",
    "notes": "Dollar General listing in Hartfort, Connecticut.",
    "selectPropertyState": "CONNECTICUT PROPERTIES",
    "askingPrice": "$ 2,053,000",
    "expires": "in 7 years",
    "built": 2016
  },
  {
    "wdtId": "467",
    "id": "250.225.009",
    "title": "MainStreet - Alachua, Florida",
    "price": "$ 2,080,000",
    "capRate": "6.25%",
    "netRent": "$ 10,833/mo",
    "priceValue": 2080000,
    "capRateValue": 6.25,
    "tenant": "MainStreet",
    "leaseTerm": "in 15 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Florida",
    "location": "Alachua, Florida",
    "yearBuilt": 2024,
    "assetType": "Service Retail",
    "corporateCredit": "50 operating locations",
    "image": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for MainStreet in Alachua, Florida. 50 operating locations",
    "status": "Active",
    "streetAddress": "16314 NW US Highway 441",
    "city": "Alachua",
    "zipCode": "32.615",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.824.200",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5081574/property",
    "notes": "50 operating locations",
    "selectPropertyState": "FLORIDA PROPERTIES",
    "askingPrice": "$ 2,080,000",
    "expires": "in 15 years",
    "built": 2024
  },
  {
    "wdtId": "468",
    "id": "250.225.001",
    "title": "Taco Bell - Sedalia, Missouri",
    "price": "$ 2,133,333",
    "capRate": "6.00%",
    "netRent": "$ 10,666/mo",
    "priceValue": 2133333,
    "capRateValue": 6,
    "tenant": "Taco Bell",
    "leaseTerm": "in 25 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Missouri",
    "location": "Sedalia, Missouri",
    "yearBuilt": 2024,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Population More than 31K within 5 Miles.",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Taco Bell in Sedalia, Missouri. Population More than 31K within 5 Miles.",
    "status": "Active",
    "streetAddress": "655 E Broadway Blvd",
    "city": "Sedalia",
    "zipCode": "65.301",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.286.645",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5150134/property",
    "notes": "Population More than 31K within 5 Miles.",
    "selectPropertyState": "MISSOURI PROPERTIES",
    "askingPrice": "$ 2,133,333",
    "expires": "in 25 years",
    "built": 2024
  },
  {
    "wdtId": "469",
    "id": "250.227.041",
    "title": "Starbucks - Abbeville, Louisiana",
    "price": "$ 2,136,800",
    "capRate": "6.00%",
    "netRent": "$ 10,684/mo",
    "priceValue": 2136800,
    "capRateValue": 6,
    "tenant": "Starbucks",
    "leaseTerm": "in 9 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Louisiana",
    "location": "Abbeville, Louisiana",
    "yearBuilt": 2024,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Starbucks listing in Abbeville, Louisiana.",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Starbucks in Abbeville, Louisiana. Starbucks listing in Abbeville, Louisiana.",
    "status": "Active",
    "streetAddress": "2207 Veterans Memorial dr",
    "city": "Abbeville",
    "zipCode": "70.510",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.288.861",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5283483/summary",
    "notes": "Starbucks listing in Abbeville, Louisiana.",
    "selectPropertyState": "LOUISIANA PROPERTIES",
    "askingPrice": "$ 2,136,800",
    "expires": "in 9 years",
    "built": 2024
  },
  {
    "wdtId": "470",
    "id": "250.227.030",
    "title": "Dollar General - Tse Bonito, New Mexico",
    "price": "$ 2,164,971",
    "capRate": "7.00%",
    "netRent": "$ 12,628/mo",
    "priceValue": 2164971,
    "capRateValue": 7,
    "tenant": "Dollar General",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "New Mexico",
    "location": "Tse Bonito, New Mexico",
    "yearBuilt": 2025,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Tse Bonito, New Mexico.",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Tse Bonito, New Mexico. Dollar General listing in Tse Bonito, New Mexico.",
    "status": "Active",
    "streetAddress": "NM-264",
    "city": "Tse Bonito",
    "zipCode": "87.301",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.830.209",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5084886/property",
    "notes": "Dollar General listing in Tse Bonito, New Mexico.",
    "selectPropertyState": "NEW MEXICO PROPERTIES",
    "askingPrice": "$ 2,164,971",
    "expires": "in 14 years",
    "built": 2025
  },
  {
    "wdtId": "471",
    "id": "250.227.007",
    "title": "Arby’s - Millington, Tennessee",
    "price": "$ 2,166,667",
    "capRate": "6.00%",
    "netRent": "$ 10,833/mo",
    "priceValue": 2166667,
    "capRateValue": 6,
    "tenant": "Arby’s",
    "leaseTerm": "in 19 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Tennessee",
    "location": "Millington, Tennessee",
    "yearBuilt": 2021,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Arby’s listing in Millington, Tennessee.",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Arby’s in Millington, Tennessee. Arby’s listing in Millington, Tennessee.",
    "status": "Active",
    "streetAddress": "8636 US Highway 51 N",
    "city": "Millington",
    "zipCode": "38.053",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.891.536",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5260970/summary",
    "notes": "Arby’s listing in Millington, Tennessee.",
    "selectPropertyState": "TENNESSEE PROPERTIES",
    "askingPrice": "$ 2,166,667",
    "expires": "in 19 years",
    "built": 2021
  },
  {
    "wdtId": "472",
    "id": "250.227.018",
    "title": "Dollar General - Townsend, Delaware",
    "price": "$ 2,183,950",
    "capRate": "6.40%",
    "netRent": "$ 11,647/mo",
    "priceValue": 2183950,
    "capRateValue": 6.4,
    "tenant": "Dollar General",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Delaware",
    "location": "Townsend, Delaware",
    "yearBuilt": 2024,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Townsend, Delaware.",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Townsend, Delaware. Dollar General listing in Townsend, Delaware.",
    "status": "Active",
    "streetAddress": "4831 DuPont Pky",
    "city": "Townsend",
    "zipCode": "19.734",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.277.690",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5145631/property",
    "notes": "Dollar General listing in Townsend, Delaware.",
    "selectPropertyState": "DELAWARE PROPERTIES",
    "askingPrice": "$ 2,183,950",
    "expires": "in 14 years",
    "built": 2024
  },
  {
    "wdtId": "473",
    "id": "250.227.027",
    "title": "Dollar General - Federalsburg, Maryland",
    "price": "$ 2,224,812",
    "capRate": "6.65%",
    "netRent": "$ 12,329/mo",
    "priceValue": 2224812,
    "capRateValue": 6.65,
    "tenant": "Dollar General",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Maryland",
    "location": "Federalsburg, Maryland",
    "yearBuilt": 2024,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Federalsburg, Maryland.",
    "image": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Federalsburg, Maryland. Dollar General listing in Federalsburg, Maryland.",
    "status": "Active",
    "streetAddress": "521 S Main St",
    "city": "Federalsburg",
    "zipCode": "21.632",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.240.147",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5124574/property/",
    "notes": "Dollar General listing in Federalsburg, Maryland.",
    "selectPropertyState": "MARYLAND PROPERTIES",
    "askingPrice": "$ 2,224,812",
    "expires": "in 14 years",
    "built": 2024
  },
  {
    "wdtId": "474",
    "id": "250.227.005",
    "title": "Burger King - South Williamson, Kentucky",
    "price": "$ 2,256,000",
    "capRate": "6.25%",
    "netRent": "$ 11,750/mo",
    "priceValue": 2256000,
    "capRateValue": 6.25,
    "tenant": "Burger King",
    "leaseTerm": "in 19 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Kentucky",
    "location": "South Williamson, Kentucky",
    "yearBuilt": 2023,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Burger King listing in South Williamson, Kentucky.",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Burger King in South Williamson, Kentucky. Burger King listing in South Williamson, Kentucky.",
    "status": "Active",
    "streetAddress": "28181 US-119",
    "city": "South Williamson",
    "zipCode": "41.503",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.821.442",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5225425/property",
    "notes": "Burger King listing in South Williamson, Kentucky.",
    "selectPropertyState": "KENTUCKY PROPERTIES",
    "askingPrice": "$ 2,256,000",
    "expires": "in 19 years",
    "built": 2023
  },
  {
    "wdtId": "475",
    "id": "250.225.013",
    "title": "Dollar General - Eureka, Montana",
    "price": "$ 2,265,000",
    "capRate": "6.25%",
    "netRent": "$ 11,796/mo",
    "priceValue": 2265000,
    "capRateValue": 6.25,
    "tenant": "Dollar General",
    "leaseTerm": "in 13 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Montana",
    "location": "Eureka, Montana",
    "yearBuilt": 2023,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General ranked #108 on Fortune 500 list in 2022",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Eureka, Montana. Dollar General ranked #108 on Fortune 500 list in 2022",
    "status": "Active",
    "streetAddress": "567 US Highway 93 N",
    "city": "Eureka",
    "zipCode": "59.917",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.273.527",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/4963364/property",
    "notes": "Dollar General ranked #108 on Fortune 500 list in 2022",
    "selectPropertyState": "MONTANA PROPERTIES",
    "askingPrice": "$ 2,265,000",
    "expires": "in 13 years",
    "built": 2023
  },
  {
    "wdtId": "476",
    "id": "250.227.034",
    "title": "Dollar General - Milledgeville, Georgia",
    "price": "$ 2,280,000",
    "capRate": "6.60%",
    "netRent": "$ 12,540/mo",
    "priceValue": 2280000,
    "capRateValue": 6.6,
    "tenant": "Dollar General",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Georgia",
    "location": "Milledgeville, Georgia",
    "yearBuilt": 2024,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Milledgeville, Georgia.",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Milledgeville, Georgia. Dollar General listing in Milledgeville, Georgia.",
    "status": "Active",
    "streetAddress": "106 Salem Church Rd SW",
    "city": "Milledgeville",
    "zipCode": "31.061",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.311.453",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5162594/summary/",
    "notes": "Dollar General listing in Milledgeville, Georgia.",
    "selectPropertyState": "GEORGIA PROPERTIES",
    "askingPrice": "$ 2,280,000",
    "expires": "in 14 years",
    "built": 2024
  },
  {
    "wdtId": "477",
    "id": "250.227.040",
    "title": "Dollar General - Westville, Oklahoma",
    "price": "$ 2,281,750",
    "capRate": "6.85%",
    "netRent": "$ 13,024/mo",
    "priceValue": 2281750,
    "capRateValue": 6.85,
    "tenant": "Dollar General",
    "leaseTerm": "in 13 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Oklahoma",
    "location": "Westville, Oklahoma",
    "yearBuilt": 2023,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Westville, Oklahoma.",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Westville, Oklahoma. Dollar General listing in Westville, Oklahoma.",
    "status": "Active",
    "streetAddress": "70787 US-59",
    "city": "Westville",
    "zipCode": "74.965",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.837.936",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5089429/summary",
    "notes": "Dollar General listing in Westville, Oklahoma.",
    "selectPropertyState": "OKLAHOMA PROPERTIES",
    "askingPrice": "$ 2,281,750",
    "expires": "in 13 years",
    "built": 2023
  },
  {
    "wdtId": "478",
    "id": "250.227.049",
    "title": "Denny's - Deland, Florida",
    "price": "$ 2,288,000",
    "capRate": "6.00%",
    "netRent": "$ 11,440/mo",
    "priceValue": 2288000,
    "capRateValue": 6,
    "tenant": "Denny's",
    "leaseTerm": "in 12 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Florida",
    "location": "Deland, Florida",
    "yearBuilt": 1993,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Denny's listing in Deland, Florida.",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Denny's in Deland, Florida. Denny's listing in Deland, Florida.",
    "status": "Active",
    "streetAddress": "1206 N Woodland Blvd",
    "city": "Deland",
    "zipCode": "32.720",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "5.507.900",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5135196/summary",
    "notes": "Denny's listing in Deland, Florida.",
    "selectPropertyState": "FLORIDA PROPERTIES",
    "askingPrice": "$ 2,288,000",
    "expires": "in 12 years",
    "built": 1993
  },
  {
    "wdtId": "479",
    "id": "250.227.028",
    "title": "Burger King - Donalsonville, Georgia",
    "price": "$ 2,333,333",
    "capRate": "6.00%",
    "netRent": "$ 11,666/mo",
    "priceValue": 2333333,
    "capRateValue": 6,
    "tenant": "Burger King",
    "leaseTerm": "in 19 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Georgia",
    "location": "Donalsonville, Georgia",
    "yearBuilt": 2024,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Burger King listing in Donalsonville, Georgia.",
    "image": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Burger King in Donalsonville, Georgia. Burger King listing in Donalsonville, Georgia.",
    "status": "Active",
    "streetAddress": "303 Morris Ave",
    "city": "Donalsonville",
    "zipCode": "39.845",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.714.806",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5037153/property/",
    "notes": "Burger King listing in Donalsonville, Georgia.",
    "selectPropertyState": "GEORGIA PROPERTIES",
    "askingPrice": "$ 2,333,333",
    "expires": "in 19 years",
    "built": 2024
  },
  {
    "wdtId": "480",
    "id": "250.227.004",
    "title": "MEDICAL - San Marcos, Texas",
    "price": "$ 2,376,559",
    "capRate": "6.25%",
    "netRent": "$ 12,377/mo",
    "priceValue": 2376559,
    "capRateValue": 6.25,
    "tenant": "MEDICAL",
    "leaseTerm": "in 6 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Texas",
    "location": "San Marcos, Texas",
    "yearBuilt": 2016,
    "assetType": "Medical / Specialty",
    "corporateCredit": "St. David's HealthCare",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for MEDICAL in San Marcos, Texas. St. David's HealthCare",
    "status": "Active",
    "streetAddress": "155 Wonder World Dr",
    "city": "San Marcos",
    "zipCode": "78.666",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "10.068.157",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5142932/property",
    "notes": "St. David's HealthCare",
    "selectPropertyState": "TEXAS PROPERTIES",
    "askingPrice": "$ 2,376,559",
    "expires": "in 6 years",
    "built": 2016
  },
  {
    "wdtId": "481",
    "id": "250.227.009",
    "title": "HARPS - Gravette, Arkansas",
    "price": "$ 2,420,561",
    "capRate": "6.50%",
    "netRent": "$ 13,111/mo",
    "priceValue": 2420561,
    "capRateValue": 6.5,
    "tenant": "HARPS",
    "leaseTerm": "in 15 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Arkansas",
    "location": "Gravette, Arkansas",
    "yearBuilt": 2017,
    "assetType": "Essential Retail",
    "corporateCredit": "Harps Food Stores",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for HARPS in Gravette, Arkansas. Harps Food Stores",
    "status": "Active",
    "streetAddress": "200 1st Ave SE",
    "city": "Gravette",
    "zipCode": "72.736",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "9.426.033",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5255161/property",
    "notes": "Harps Food Stores",
    "selectPropertyState": "ARKANSAS PROPERTIES",
    "askingPrice": "$ 2,420,561",
    "expires": "in 15 years",
    "built": 2017
  },
  {
    "wdtId": "482",
    "id": "250.227.037",
    "title": "Family Dollar - Butler, Kentucky",
    "price": "$ 2,433,036",
    "capRate": "6.75%",
    "netRent": "$ 13,685/mo",
    "priceValue": 2433036,
    "capRateValue": 6.75,
    "tenant": "Family Dollar",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Kentucky",
    "location": "Butler, Kentucky",
    "yearBuilt": 2024,
    "assetType": "Essential Retail",
    "corporateCredit": "Family Dollar listing in Butler, Kentucky.",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Family Dollar in Butler, Kentucky. Family Dollar listing in Butler, Kentucky.",
    "status": "Active",
    "streetAddress": "10163 US Highway 27 N",
    "city": "Butler",
    "zipCode": "41.006",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "9.186.169",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5206820/summary",
    "notes": "Family Dollar listing in Butler, Kentucky.",
    "selectPropertyState": "KENTUCKY PROPERTIES",
    "askingPrice": "$ 2,433,036",
    "expires": "in 14 years",
    "built": 2024
  },
  {
    "wdtId": "483",
    "id": "250.227.035",
    "title": "Dollar General - Hoover, Alabama",
    "price": "$ 2,505,046",
    "capRate": "6.50%",
    "netRent": "$ 13,568/mo",
    "priceValue": 2505046,
    "capRateValue": 6.5,
    "tenant": "Dollar General",
    "leaseTerm": "in 14 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Alabama",
    "location": "Hoover, Alabama",
    "yearBuilt": 2024,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Hoover, Alabama.",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Dollar General in Hoover, Alabama. Dollar General listing in Hoover, Alabama.",
    "status": "Active",
    "streetAddress": "2070 Shannon Oxmoor Rd",
    "city": "Hoover",
    "zipCode": "35.022",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.248.784",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5129737/summary/",
    "notes": "Dollar General listing in Hoover, Alabama.",
    "selectPropertyState": "ALABAMA PROPERTIES",
    "askingPrice": "$ 2,505,046",
    "expires": "in 14 years",
    "built": 2024
  },
  {
    "wdtId": "484",
    "id": "250.227.038",
    "title": "Dollar General - Dublin, Georgia",
    "price": "$ 2,510,031",
    "capRate": "6.50%",
    "netRent": "$ 13,596/mo",
    "priceValue": 2510031,
    "capRateValue": 6.5,
    "tenant": "Dollar General",
    "leaseTerm": "in 9 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Georgia",
    "location": "Dublin, Georgia",
    "yearBuilt": 2024,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Dublin, Georgia.",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Dublin, Georgia. Dollar General listing in Dublin, Georgia.",
    "status": "Active",
    "streetAddress": "2718 US Highway 441 S",
    "city": "Dublin",
    "zipCode": "31.021",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.307.238",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5160348/summary/",
    "notes": "Dollar General listing in Dublin, Georgia.",
    "selectPropertyState": "GEORGIA PROPERTIES",
    "askingPrice": "$ 2,510,031",
    "expires": "in 9 years",
    "built": 2024
  },
  {
    "wdtId": "485",
    "id": "250.227.008",
    "title": "MEDICAL - Bessemer, Alabama",
    "price": "$ 2,540,500",
    "capRate": "6.01%",
    "netRent": "$ 12,723/mo",
    "priceValue": 2540500,
    "capRateValue": 6.01,
    "tenant": "MEDICAL",
    "leaseTerm": "in 15 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Alabama",
    "location": "Bessemer, Alabama",
    "yearBuilt": 2016,
    "assetType": "Medical / Specialty",
    "corporateCredit": "American Family Care",
    "image": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for MEDICAL in Bessemer, Alabama. American Family Care",
    "status": "Active",
    "streetAddress": "5911 Harris Ln",
    "city": "Bessemer",
    "zipCode": "35.022",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "9.922.889",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5102114/summary",
    "notes": "American Family Care",
    "selectPropertyState": "ALABAMA PROPERTIES",
    "askingPrice": "$ 2,540,500",
    "expires": "in 15 years",
    "built": 2016
  },
  {
    "wdtId": "486",
    "id": "250.227.046",
    "title": "7 Brew - Jacksonville, Florida",
    "price": "$ 2,599,000",
    "capRate": "6.35%",
    "netRent": "$ 13,753/mo",
    "priceValue": 2599000,
    "capRateValue": 6.35,
    "tenant": "7 Brew",
    "leaseTerm": "in 15 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Florida",
    "location": "Jacksonville, Florida",
    "yearBuilt": 2023,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "7 Brew listing in Jacksonville, Florida.",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for 7 Brew in Jacksonville, Florida. 7 Brew listing in Jacksonville, Florida.",
    "status": "Active",
    "streetAddress": "3264 Gerona E dr",
    "city": "Jacksonville",
    "zipCode": "32.224",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.222.715",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5021626/summary",
    "notes": "7 Brew listing in Jacksonville, Florida.",
    "selectPropertyState": "FLORIDA PROPERTIES",
    "askingPrice": "$ 2,599,000",
    "expires": "in 15 years",
    "built": 2023
  },
  {
    "wdtId": "487",
    "id": "250.227.029",
    "title": "Dollar General - Lexington, North Carolina",
    "price": "$ 2,675,000",
    "capRate": "6.50%",
    "netRent": "$ 14,489/mo",
    "priceValue": 2675000,
    "capRateValue": 6.5,
    "tenant": "Dollar General",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "North Carolina",
    "location": "Lexington, North Carolina",
    "yearBuilt": 2025,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Lexington, North Carolina.",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Lexington, North Carolina. Dollar General listing in Lexington, North Carolina.",
    "status": "Active",
    "streetAddress": "3653 NC-8",
    "city": "Lexington",
    "zipCode": "27.292",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.902.709",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5267780/property/",
    "notes": "Dollar General listing in Lexington, North Carolina.",
    "selectPropertyState": "NORTH CAROLINA PROPERTIES",
    "askingPrice": "$ 2,675,000",
    "expires": "in 14 years",
    "built": 2025
  },
  {
    "wdtId": "488",
    "id": "250.225.004",
    "title": "Starbucks - Oswego, Illinois",
    "price": "$ 2,805,000",
    "capRate": "6.15%",
    "netRent": "$ 14,375/mo",
    "priceValue": 2805000,
    "capRateValue": 6.15,
    "tenant": "Starbucks",
    "leaseTerm": "in 12 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Illinois",
    "location": "Oswego, Illinois",
    "yearBuilt": 2025,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Single-Tenant Corporate (NASDAQ: SBUX; S&P: BBB+) Starbucks Drive-Thru",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Starbucks in Oswego, Illinois. Single-Tenant Corporate (NASDAQ: SBUX; S&P: BBB+) Starbucks Drive-Thru",
    "status": "Active",
    "streetAddress": "Orchard Road Starbucks",
    "city": "Oswego",
    "zipCode": "60.543",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.817.465",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5256096/summary",
    "notes": "Single-Tenant Corporate (NASDAQ: SBUX; S&P: BBB+) Starbucks Drive-Thru",
    "selectPropertyState": "ILLINOIS PROPERTIES",
    "askingPrice": "$ 2,805,000",
    "expires": "in 12 years",
    "built": 2025
  },
  {
    "wdtId": "489",
    "id": "250.227.019",
    "title": "Dollar General - Blanding, Utah",
    "price": "$ 2,806,000",
    "capRate": "6.25%",
    "netRent": "$ 14,614/mo",
    "priceValue": 2806000,
    "capRateValue": 6.25,
    "tenant": "Dollar General",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Utah",
    "location": "Blanding, Utah",
    "yearBuilt": 2025,
    "assetType": "Essential Retail",
    "corporateCredit": "Dollar General listing in Blanding, Utah.",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Dollar General in Blanding, Utah. Dollar General listing in Blanding, Utah.",
    "status": "Active",
    "streetAddress": "E 500 S",
    "city": "Blanding",
    "zipCode": "84.511",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.289.703",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5151618/summary",
    "notes": "Dollar General listing in Blanding, Utah.",
    "selectPropertyState": "UTAH PROPERTIES",
    "askingPrice": "$ 2,806,000",
    "expires": "in 14 years",
    "built": 2025
  },
  {
    "wdtId": "490",
    "id": "250.227.044",
    "title": "Burger King - Crestview, Florida",
    "price": "$ 2,811,000",
    "capRate": "6.20%",
    "netRent": "$ 14,523/mo",
    "priceValue": 2811000,
    "capRateValue": 6.2,
    "tenant": "Burger King",
    "leaseTerm": "in 19 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Florida",
    "location": "Crestview, Florida",
    "yearBuilt": 2023,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Burger King listing in Crestview, Florida.",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Burger King in Crestview, Florida. Burger King listing in Crestview, Florida.",
    "status": "Active",
    "streetAddress": "Hwy 85 N & Old Bethel Rd",
    "city": "Crestview",
    "zipCode": "32.536",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.296.062",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5154538/summary",
    "notes": "Burger King listing in Crestview, Florida.",
    "selectPropertyState": "FLORIDA PROPERTIES",
    "askingPrice": "$ 2,811,000",
    "expires": "in 19 years",
    "built": 2023
  },
  {
    "wdtId": "491",
    "id": "250.227.001",
    "title": "WhatABurger - Hazel Green, Alabama",
    "price": "$ 2,900,000",
    "capRate": "6.25%",
    "netRent": "$ 15,104/mo",
    "priceValue": 2900000,
    "capRateValue": 6.25,
    "tenant": "WhatABurger",
    "leaseTerm": "in 19 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Alabama",
    "location": "Hazel Green, Alabama",
    "yearBuilt": 2023,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Rent increases of 10% every 5 yrs of the Primary Lease",
    "image": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for WhatABurger in Hazel Green, Alabama. Rent increases of 10% every 5 yrs of the Primary Lease",
    "status": "Active",
    "streetAddress": "14751 US-231-",
    "city": "Hazel Green",
    "zipCode": "35.750",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.248.779",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5245511/summary",
    "notes": "Rent increases of 10% every 5 yrs of the Primary Lease",
    "selectPropertyState": "ALABAMA PROPERTIES",
    "askingPrice": "$ 2,900,000",
    "expires": "in 19 years",
    "built": 2023
  },
  {
    "wdtId": "492",
    "id": "250.227.048",
    "title": "Del Taco - Defuniak Springs, Florida",
    "price": "$ 2,922,000",
    "capRate": "6.25%",
    "netRent": "$ 15,218/mo",
    "priceValue": 2922000,
    "capRateValue": 6.25,
    "tenant": "Del Taco",
    "leaseTerm": "in 9 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Florida",
    "location": "Defuniak Springs, Florida",
    "yearBuilt": 2024,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Del Taco listing in Defuniak Springs, Florida.",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Del Taco in Defuniak Springs, Florida. Del Taco listing in Defuniak Springs, Florida.",
    "status": "Active",
    "streetAddress": "2760 US Hwy 331 S",
    "city": "Defuniak Springs",
    "zipCode": "32.435",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.723.188",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5159645/summary",
    "notes": "Del Taco listing in Defuniak Springs, Florida.",
    "selectPropertyState": "FLORIDA PROPERTIES",
    "askingPrice": "$ 2,922,000",
    "expires": "in 9 years",
    "built": 2024
  },
  {
    "wdtId": "493",
    "id": "250.227.039",
    "title": "MEDICAL - Florissant, Missouri",
    "price": "$ 2,972,000",
    "capRate": "6.65%",
    "netRent": "$ 16,469/mo",
    "priceValue": 2972000,
    "capRateValue": 6.65,
    "tenant": "MEDICAL",
    "leaseTerm": "in 12 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Missouri",
    "location": "Florissant, Missouri",
    "yearBuilt": 2016,
    "assetType": "Medical / Specialty",
    "corporateCredit": "MEDICAL listing in Florissant, Missouri.",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for MEDICAL in Florissant, Missouri. MEDICAL listing in Florissant, Missouri.",
    "status": "Active",
    "streetAddress": "1090 N US Highway 67",
    "city": "Florissant",
    "zipCode": "63.031",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "9.333.463",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5239809/property/",
    "notes": "MEDICAL listing in Florissant, Missouri.",
    "selectPropertyState": "MISSOURI PROPERTIES",
    "askingPrice": "$ 2,972,000",
    "expires": "in 12 years",
    "built": 2016
  },
  {
    "wdtId": "494",
    "id": "250.227.016",
    "title": "Slim Chickens - Florence, Alabama",
    "price": "$ 3,252,000",
    "capRate": "6.00%",
    "netRent": "$ 16,260/mo",
    "priceValue": 3252000,
    "capRateValue": 6,
    "tenant": "Slim Chickens",
    "leaseTerm": "in 18 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Alabama",
    "location": "Florence, Alabama",
    "yearBuilt": 2023,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Slim Chickens listing in Florence, Alabama.",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Slim Chickens in Florence, Alabama. Slim Chickens listing in Florence, Alabama.",
    "status": "Active",
    "streetAddress": "3201 Cloverdale Rd",
    "city": "Florence",
    "zipCode": "35.633",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "13.831.646",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5097344/property",
    "notes": "Slim Chickens listing in Florence, Alabama.",
    "selectPropertyState": "ALABAMA PROPERTIES",
    "askingPrice": "$ 3,252,000",
    "expires": "in 18 years",
    "built": 2023
  },
  {
    "wdtId": "495",
    "id": "250.227.010",
    "title": "Popeyes - Hermiston, Oregon",
    "price": "$ 3,440,000",
    "capRate": "6.25%",
    "netRent": "$ 17,916/mo",
    "priceValue": 3440000,
    "capRateValue": 6.25,
    "tenant": "Popeyes",
    "leaseTerm": "in 18 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Oregon",
    "location": "Hermiston, Oregon",
    "yearBuilt": 2023,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Popeyes listing in Hermiston, Oregon.",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Popeyes in Hermiston, Oregon. Popeyes listing in Hermiston, Oregon.",
    "status": "Active",
    "streetAddress": "1680 N 1st Pl",
    "city": "Hermiston",
    "zipCode": "97.838",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.924.548",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5282466/property",
    "notes": "Popeyes listing in Hermiston, Oregon.",
    "selectPropertyState": "OREGON PROPERTIES",
    "askingPrice": "$ 3,440,000",
    "expires": "in 18 years",
    "built": 2023
  },
  {
    "wdtId": "496",
    "id": "250.227.021",
    "title": "Beef-A-Roo - Carrollton, Texas",
    "price": "$ 3,681,563",
    "capRate": "8.00%",
    "netRent": "$ 24,543/mo",
    "priceValue": 3681563,
    "capRateValue": 8,
    "tenant": "Beef-A-Roo",
    "leaseTerm": "in 18 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Texas",
    "location": "Carrollton, Texas",
    "yearBuilt": 2016,
    "assetType": "QSR / Drive-Thru",
    "corporateCredit": "Beef-A-Roo listing in Carrollton, Texas.",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Beef-A-Roo in Carrollton, Texas. Beef-A-Roo listing in Carrollton, Texas.",
    "status": "Active",
    "streetAddress": "1501 W Hebron Pky",
    "city": "Carrollton",
    "zipCode": "75.010",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "9.876.233",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5062249/property",
    "notes": "Beef-A-Roo listing in Carrollton, Texas.",
    "selectPropertyState": "TEXAS PROPERTIES",
    "askingPrice": "$ 3,681,563",
    "expires": "in 18 years",
    "built": 2016
  },
  {
    "wdtId": "497",
    "id": "250.225.008",
    "title": "Medical - Houston, Texas",
    "price": "$ 4,000,000",
    "capRate": "6.00%",
    "netRent": "$ 20,000/mo",
    "priceValue": 4000000,
    "capRateValue": 6,
    "tenant": "Medical",
    "leaseTerm": "in 10 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Texas",
    "location": "Houston, Texas",
    "yearBuilt": 2019,
    "assetType": "Medical / Specialty",
    "corporateCredit": "two 5-Year Options",
    "image": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Medical in Houston, Texas. two 5-Year Options",
    "status": "Active",
    "streetAddress": "17030 Northwest Fwy",
    "city": "Houston",
    "zipCode": "77.040",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "10.096.520",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5215899/property",
    "notes": "two 5-Year Options",
    "selectPropertyState": "TEXAS PROPERTIES",
    "askingPrice": "$ 4,000,000",
    "expires": "in 10 years",
    "built": 2019
  },
  {
    "wdtId": "498",
    "id": "250.227.020",
    "title": "CVS Health - Spring, Texas",
    "price": "$ 4,004,391",
    "capRate": "6.32%",
    "netRent": "$ 21,089/mo",
    "priceValue": 4004391,
    "capRateValue": 6.32,
    "tenant": "CVS Health",
    "leaseTerm": "in 18 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Texas",
    "location": "Spring, Texas",
    "yearBuilt": 2017,
    "assetType": "Medical / Specialty",
    "corporateCredit": "CVS Health listing in Spring, Texas.",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for CVS Health in Spring, Texas. CVS Health listing in Spring, Texas.",
    "status": "Active",
    "streetAddress": "10833 Gleannloch Forest Dr",
    "city": "Spring",
    "zipCode": "77.379",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "10.315.301",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5224489/property",
    "notes": "CVS Health listing in Spring, Texas.",
    "selectPropertyState": "TEXAS PROPERTIES",
    "askingPrice": "$ 4,004,391",
    "expires": "in 18 years",
    "built": 2017
  },
  {
    "wdtId": "499",
    "id": "250.227.011",
    "title": "Parachute - Fremont, Nebraska",
    "price": "$ 5,343,379",
    "capRate": "7.50%",
    "netRent": "$ 33,396/mo",
    "priceValue": 5343379,
    "capRateValue": 7.5,
    "tenant": "Parachute",
    "leaseTerm": "in 20 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Nebraska",
    "location": "Fremont, Nebraska",
    "yearBuilt": 2024,
    "assetType": "NNN Investment",
    "corporateCredit": "Parachute listing in Fremont, Nebraska.",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Parachute in Fremont, Nebraska. Parachute listing in Fremont, Nebraska.",
    "status": "Active",
    "streetAddress": "3643 E 24th St",
    "city": "Fremont",
    "zipCode": "68.025",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.852.921",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5239775/summary",
    "notes": "Parachute listing in Fremont, Nebraska.",
    "selectPropertyState": "NEBRASKA PROPERTIES",
    "askingPrice": "$ 5,343,379",
    "expires": "in 20 years",
    "built": 2024
  },
  {
    "wdtId": "500",
    "id": "250.227.022",
    "title": "Walgreens - Gretna, Nebraska",
    "price": "$ 5,661,538",
    "capRate": "6.50%",
    "netRent": "$ 30,666/mo",
    "priceValue": 5661538,
    "capRateValue": 6.5,
    "tenant": "Walgreens",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Nebraska",
    "location": "Gretna, Nebraska",
    "yearBuilt": 2024,
    "assetType": "Essential Retail",
    "corporateCredit": "Walgreens listing in Gretna, Nebraska.",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Walgreens in Gretna, Nebraska. Walgreens listing in Gretna, Nebraska.",
    "status": "Active",
    "streetAddress": "10819 S 192nd Ave",
    "city": "Gretna",
    "zipCode": "68.028",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "18.887.720",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5285490/summary",
    "notes": "Walgreens listing in Gretna, Nebraska.",
    "selectPropertyState": "NEBRASKA PROPERTIES",
    "askingPrice": "$ 5,661,538",
    "expires": "in 14 years",
    "built": 2024
  },
  {
    "wdtId": "501",
    "id": "250.227.033",
    "title": "MEDICAL - Sutton, Massachusetts",
    "price": "$ 6,520,800",
    "capRate": "6.00%",
    "netRent": "$ 32,604/mo",
    "priceValue": 6520800,
    "capRateValue": 6,
    "tenant": "MEDICAL",
    "leaseTerm": "in 14 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Massachusetts",
    "location": "Sutton, Massachusetts",
    "yearBuilt": 2024,
    "assetType": "Medical / Specialty",
    "corporateCredit": "MEDICAL listing in Sutton, Massachusetts.",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for MEDICAL in Sutton, Massachusetts. MEDICAL listing in Sutton, Massachusetts.",
    "status": "Active",
    "streetAddress": "15 Pleasant Valley Rd",
    "city": "Sutton",
    "zipCode": "1.590",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.923.040",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5082521/summary",
    "notes": "MEDICAL listing in Sutton, Massachusetts.",
    "selectPropertyState": "MASSACHUSETTS PROPERTIES",
    "askingPrice": "$ 6,520,800",
    "expires": "in 14 years",
    "built": 2024
  },
  {
    "wdtId": "502",
    "id": "250.227.002",
    "title": "Kiddie Academy - Oak Park, Illinois",
    "price": "$ 6,735,000",
    "capRate": "7.00%",
    "netRent": "$ 39,287/mo",
    "priceValue": 6735000,
    "capRateValue": 7,
    "tenant": "Kiddie Academy",
    "leaseTerm": "in 19 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Illinois",
    "location": "Oak Park, Illinois",
    "yearBuilt": 2023,
    "assetType": "Medical / Specialty",
    "corporateCredit": "School",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Kiddie Academy in Oak Park, Illinois. School",
    "status": "Active",
    "streetAddress": "1117 Garfield",
    "city": "Oak Park",
    "zipCode": "60.304",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "13.922.561",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5104086/property",
    "notes": "School",
    "selectPropertyState": "ILLINOIS PROPERTIES",
    "askingPrice": "$ 6,735,000",
    "expires": "in 19 years",
    "built": 2023
  },
  {
    "wdtId": "503",
    "id": "250.227.023",
    "title": "Napa Auto Parts - Wilmington, North Carolina",
    "price": "$ 8,128,640",
    "capRate": "6.25%",
    "netRent": "$ 42,336/mo",
    "priceValue": 8128640,
    "capRateValue": 6.25,
    "tenant": "Napa Auto Parts",
    "leaseTerm": "in 9 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "North Carolina",
    "location": "Wilmington, North Carolina",
    "yearBuilt": 2023,
    "assetType": "Essential Retail",
    "corporateCredit": "Napa Auto Parts listing in Wilmington, North Carolina.",
    "image": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Napa Auto Parts in Wilmington, North Carolina. Napa Auto Parts listing in Wilmington, North Carolina.",
    "status": "Active",
    "streetAddress": "3722 Market St",
    "city": "Wilmington",
    "zipCode": "28.403",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "13.892.931",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5295091/summary",
    "notes": "Napa Auto Parts listing in Wilmington, North Carolina.",
    "selectPropertyState": "NORTH CAROLINA PROPERTIES",
    "askingPrice": "$ 8,128,640",
    "expires": "in 9 years",
    "built": 2023
  },
  {
    "wdtId": "504",
    "id": "250.227.012",
    "title": "Walmart - Alabaster, Alabama",
    "price": "$ 8,820,000",
    "capRate": "6.30%",
    "netRent": "$ 46,305/mo",
    "priceValue": 8820000,
    "capRateValue": 6.3,
    "tenant": "Walmart",
    "leaseTerm": "in 5 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Alabama",
    "location": "Alabaster, Alabama",
    "yearBuilt": 2015,
    "assetType": "Essential Retail",
    "corporateCredit": "Walmart listing in Alabaster, Alabama.",
    "image": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Walmart in Alabaster, Alabama. Walmart listing in Alabaster, Alabama.",
    "status": "Active",
    "streetAddress": "9085 Al-119 Hwy",
    "city": "Alabaster",
    "zipCode": "35.007",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "9.685.509",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5236294/property",
    "notes": "Walmart listing in Alabaster, Alabama.",
    "selectPropertyState": "ALABAMA PROPERTIES",
    "askingPrice": "$ 8,820,000",
    "expires": "in 5 years",
    "built": 2015
  },
  {
    "wdtId": "505",
    "id": "250.227.024",
    "title": "Harps Food - Brookland, Arizona",
    "price": "$ 8,922,777",
    "capRate": "6.50%",
    "netRent": "$ 48,331/mo",
    "priceValue": 8922777,
    "capRateValue": 6.5,
    "tenant": "Harps Food",
    "leaseTerm": "in 15 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Arizona",
    "location": "Brookland, Arizona",
    "yearBuilt": 2024,
    "assetType": "Essential Retail",
    "corporateCredit": "Harps Food listing in Brookland, Arizona.",
    "image": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Harps Food in Brookland, Arizona. Harps Food listing in Brookland, Arizona.",
    "status": "Active",
    "streetAddress": "8107 A Highway 49",
    "city": "Brookland",
    "zipCode": "72.417",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.416.701",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5255070/summary/",
    "notes": "Harps Food listing in Brookland, Arizona.",
    "selectPropertyState": "ARIZONA PROPERTIES",
    "askingPrice": "$ 8,922,777",
    "expires": "in 15 years",
    "built": 2024
  },
  {
    "wdtId": "506",
    "id": "250.225.007",
    "title": "MedVet - Hilliard, Ohio",
    "price": "$ 14,600,000",
    "capRate": "6.00%",
    "netRent": "$ 73,000/mo",
    "priceValue": 14600000,
    "capRateValue": 6,
    "tenant": "MedVet",
    "leaseTerm": "in 15 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Ohio",
    "location": "Hilliard, Ohio",
    "yearBuilt": 2024,
    "assetType": "Medical / Specialty",
    "corporateCredit": "MedVet listing in Hilliard, Ohio.",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for MedVet in Hilliard, Ohio. MedVet listing in Hilliard, Ohio.",
    "status": "Active",
    "streetAddress": "4050 Britton Pky",
    "city": "Hilliard",
    "zipCode": "43.026",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "19.714.356",
    "linkToProperty": "For Sale | 4050 Britton Pky - MedVet",
    "notes": "MedVet listing in Hilliard, Ohio.",
    "selectPropertyState": "OHIO PROPERTIES",
    "askingPrice": "$ 14,600,000",
    "expires": "in 15 years",
    "built": 2024
  },
  {
    "wdtId": "507",
    "id": "250.225.010",
    "title": "Kohl's - Lutz, Florida",
    "price": "$ 14,732,000",
    "capRate": "7.00%",
    "netRent": "$ 85,936/mo",
    "priceValue": 14732000,
    "capRateValue": 7,
    "tenant": "Kohl's",
    "leaseTerm": "in 12 years",
    "rentType": "Absolute NNN",
    "landlord": "Has zero responsibility",
    "state": "Florida",
    "location": "Lutz, Florida",
    "yearBuilt": 2024,
    "assetType": "NNN Investment",
    "corporateCredit": "Kohl's listing in Lutz, Florida.",
    "image": "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1400&q=80",
    "description": "Active Absolute NNN listing for Kohl's in Lutz, Florida. Kohl's listing in Lutz, Florida.",
    "status": "Active",
    "streetAddress": "1854 Sun Vista Dr",
    "city": "Lutz",
    "zipCode": "33.559",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "20.287.415",
    "linkToProperty": "For Sale | 1854 Sun Vista Dr - KOHL's",
    "notes": "Kohl's listing in Lutz, Florida.",
    "selectPropertyState": "FLORIDA PROPERTIES",
    "askingPrice": "$ 14,732,000",
    "expires": "in 12 years",
    "built": 2024
  },
  {
    "wdtId": "508",
    "id": "250.227.006",
    "title": "Northrop Grum. - Gilbert, Arizona",
    "price": "$ 56,671,000",
    "capRate": "6.25%",
    "netRent": "$ 295,161/mo",
    "priceValue": 56671000,
    "capRateValue": 6.25,
    "tenant": "Northrop Grum.",
    "leaseTerm": "in 12 years",
    "rentType": "NNN",
    "landlord": "Has minimal responsibility",
    "state": "Arizona",
    "location": "Gilbert, Arizona",
    "yearBuilt": 2025,
    "assetType": "Industrial / Corporate",
    "corporateCredit": "Northrop Grumman Systems Corporation",
    "image": "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1400&q=80",
    "description": "Active NNN listing for Northrop Grum. in Gilbert, Arizona. Northrop Grumman Systems Corporation",
    "status": "Active",
    "streetAddress": "1655 E Elliot Rd",
    "city": "Gilbert",
    "zipCode": "85.233",
    "propertyInfoSource": "CoStar",
    "originalPropertyId": "12.298.210",
    "linkToProperty": "https://product.costar.com/detail/for-sale/default/5276764/property",
    "notes": "Northrop Grumman Systems Corporation",
    "selectPropertyState": "ARIZONA PROPERTIES",
    "askingPrice": "$ 56,671,000",
    "expires": "in 12 years",
    "built": 2025
  }
];

export const states = [
  "All States",
  "Alabama",
  "Arizona",
  "Arkansas",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Illinois",
  "Indiana",
  "Kentucky",
  "Louisiana",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Missouri",
  "Montana",
  "Nebraska",
  "New Mexico",
  "North Carolina",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "South Carolina",
  "Tennessee",
  "Texas",
  "Utah",
  "West Virginia",
  "Wyoming"
];
